<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'gestoesDeAulas' })"
            :disabled="submittingForm">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Vínculo
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="Professor" :rules="professorNaoListado ? 'required' : 'required'"
              v-slot="{ errors }">
              <e-label>
                Professor
                <span class="red--text" v-if="!professorNaoListado">*</span>
              </e-label>
              <e-autocomplete v-if="!professorNaoListado" :items="professoresList" :return-object="false"
                :item-value="(value) => value.id" :item-text="(val) => `${val.cpf} - ${val.nome}`"
                :error-messages="errors" :loading="carregandoProfessores" v-model="form.instrutor_id"
                label="Selecione uma opção" dense solo />
              <e-autocomplete v-else v-model="form.professor_nao_listado" :items="usersSemProfessor"
                :item-value="(val) => val.id" :item-text="(val) => `${val.name} (${val.email})`"
                :error-messages="errors" label="Selecione o usuário" dense solo />
            </ValidationProvider>

            <v-switch v-model="professorNaoListado" label="Professor não está listado"
              hint="Marque esta opção se o professor não estiver na lista de docentes regulares" persistent-hint inset
              class="mt-2" color="primary" @change="handleProfessorNaoListadoChange"></v-switch>
          </v-col>
          <v-dialog v-model="modalCriarProfessor" max-width="800px" persistent>
            <v-card>
              <v-card-title class="headline primary white--text">
                <v-icon left dark>mdi-account-plus</v-icon>
                Cadastrar Novo Professor
              </v-card-title>

              <v-divider></v-divider>

              <v-stepper v-model="etapaCriacaoProfessor" flat>
                <v-stepper-header class="elevation-0">
                  <v-stepper-step step="1" :complete="etapaCriacaoProfessor > 1" editable color="primary">
                    Dados Pessoais
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="2" :complete="etapaCriacaoProfessor > 2" editable color="primary">
                    Confirmação
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <!-- Etapa 1 - Dados Pessoais -->
                  <v-stepper-content step="1">
                    <v-form ref="formEtapa1" lazy-validation>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field label="Nome Completo*" v-model="novoProfessor.nome" outlined dense
                              prepend-inner-icon="mdi-account" readonly />
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-text-field label="E-mail*" v-model="novoProfessor.email" outlined dense
                              prepend-inner-icon="mdi-email" readonly />
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-text-field label="CPF*" v-mask="'###.###.###-##'" v-model="novoProfessor.cpf" outlined
                              dense prepend-inner-icon="mdi-card-account-details" hint="Formato: 000.000.000-00"
                              persistent-hint :rules="[regraCPF]" />
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-menu ref="menuDataNascimento" v-model="menuDataNascimento"
                              :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="novoProfessor.dataNascimento" label="Data de Nascimento*"
                                  prepend-inner-icon="mdi-calendar" readonly outlined dense v-bind="attrs"
                                  v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="novoProfessor.dataNascimento"
                                :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" locale="pt-BR"
                                @input="menuDataNascimento = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>

                    <v-card-actions class="justify-end">
                      <v-btn color="primary" @click="proximaEtapa" :disabled="!dadosEtapa1Validos" depressed>
                        Continuar
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-stepper-content>

                  <!-- Etapa 2 - Confirmação -->
                  <v-stepper-content step="2">
                    <v-card outlined class="mb-4">
                      <v-card-title class="subtitle-1">Resumo dos Dados</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Nome</v-list-item-title>
                              <v-list-item-subtitle>{{ novoProfessor.nome }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-email</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>E-mail</v-list-item-title>
                              <v-list-item-subtitle>{{ novoProfessor.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-card-account-details</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>CPF</v-list-item-title>
                              <v-list-item-subtitle>{{
                                formatarCPF(novoProfessor.cpf)
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-calendar</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Data de Nascimento</v-list-item-title>
                              <v-list-item-subtitle>{{
                                formatarData(novoProfessor.dataNascimento)
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>

                    <v-alert v-if="erroCadastro" type="error" dense outlined class="mb-4">
                      {{ erroCadastro }}
                    </v-alert>

                    <v-card-actions class="justify-space-between">
                      <v-btn text @click="etapaCriacaoProfessor = 1" color="grey darken-1">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>

                      <div>
                        <v-btn text @click="modalCriarProfessor = false" class="mr-2">
                          Cancelar
                        </v-btn>

                        <v-btn color="primary" @click="salvarNovoProfessor" :loading="salvando" depressed>
                          <v-icon left>mdi-content-save</v-icon>
                          Confirmar Cadastro
                        </v-btn>
                      </div>
                    </v-card-actions>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card>
          </v-dialog>
        </v-row>

        <v-row class="animate__animated animate__zoomIn" style="animation-duration: 0.5s" v-for="relacao of relacoes"
          :key="relacoes.indexOf(relacao)">
          <v-col class="pt-0 pb-0" cols="12" xs="12" sm="12" md="4">
            <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
              <e-label>Turma</e-label>
              <e-autocomplete :items="turmasList" :return-object="false" :item-value="(value) => value.id"
                :item-text="(val) => `${val.descricao} - (${val.turno.descricao})`"
                :error-messages="relacao.errors ? relacao.errors : errors" :loading="carregandoTurmas"
                v-model="relacao.turma_id" :disabled="editing" @change="getHorariosDaTurma(relacao.turma_id)"
                label="Selecione uma opção" dense solo />
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12" xs="12" sm="8" md="4">
            <ValidationProvider name="Disciplina" rules="required" v-slot="{ errors }">
              <e-label>Disciplina</e-label>
              <e-autocomplete :items="disciplinasList" :return-object="false" :item-value="(value) => value.id"
                :item-text="(val) => val.descricao" :error-messages="relacao.errors ? relacao.errors : errors"
                :loading="carregandoDisciplinas" v-model="relacao.disciplina_id" :disabled="editing"
                label="Selecione uma opção" dense solo />
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <template>
              <v-container fluid>
                <v-checkbox v-model="relacao.nao_compor_boletim_nem_ata" :label="`Não compor BOLETIM/ATA`"></v-checkbox>
              </v-container>
            </template>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12" xs="12" sm="4" md="4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider name="Carga horária" rules="required|regex:^[0-9]+$" v-slot="{ errors }">
                  <e-label>CH SEMANAL</e-label>
                  <v-text-field :error-messages="errors" v-bind="attrs" v-on="on" v-model="relacao.carga_horaria"
                    label="20 (Apenas números)" dense solo />
                </ValidationProvider>
              </template>
              <span>Carga horária semanal do professor</span>
            </v-tooltip>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12" xs="12" sm="4" md="4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider name="Carga anual" rules="required|regex:^[0-9]+$" v-slot="{ errors }">
                  <e-label>CH ANUAL</e-label>
                  <v-text-field :error-messages="errors" v-bind="attrs" v-on="on" v-model="relacao.ch_anual_disciplina"
                    label="200 (Apenas números)" dense solo />
                </ValidationProvider>
              </template>
              <span>Carga horária anual da disciplina</span>
            </v-tooltip>
          </v-col>

          <v-dialog transition="dialog-top-transition" v-model="dialogVisible" max-width="800">
            <template v-slot:activator="{ on, attrs }">
              <v-col class="pt-0 pb-0" cols="12" xs="12" sm="4" md="4">
                <v-btn color="green white--text" v-bind="attrs" v-on="on" class="mt-7" cols="12" xs="12" sm="12"
                  md="12">
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-col>
            </template>
            <template>
              <v-card cols="12" xs="12" sm="12" md="12">
                <v-toolbar color="primary" dark>Vínculo de dias e horários
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogVisible = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-row class="mt-4">
                    <v-col class="pt-0 pb-0" cols="4">
                      <e-label>Dias da semana</e-label>
                      <v-select v-model="dia_da_semana" :items="diasDaSemana" :return-object="false"
                        :item-value="(value) => value" :item-text="(value) => value.descricao" dense solo
                        label="selecione"></v-select>
                    </v-col>

                    <v-col class="pt-0 pb-0" cols="4">
                      <e-label>Horarios</e-label>
                      <v-select v-model="horario_selecionado_id" :items="horariosList" :return-object="false"
                        :item-value="(value) => value" :item-text="(value) => value.descricao" dense solo
                        label="selecione"></v-select>
                    </v-col>

                    <v-col class="pt-7 pb-0" cols="4">
                      <v-btn :disabled="!dia_da_semana || !horario_selecionado_id" color="green" class="white--text"
                        @click="adicionarHorario(relacoes.indexOf(relacao))">+ adicionar</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-col v-if="!editing">
                  <v-timeline v-show="relacoes.indexOf(relacao) == item.relacao_id" align-top dense
                    v-for="(item, i) in relacoesDiasHorarios" :key="i">
                    <v-timeline-item><v-chip class="mt-1" color="green" text-color="white">
                        {{ item.dia.descricao }}
                        | {{ item.horario.descricao }}
                      </v-chip>
                      <v-btn class="ml-2" @click="deleteRelacaoDiaHorario(i, relacoes.indexOf(relacao))" color="error"
                        fab small dark>
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>

                <v-col v-if="editing">
                  <v-timeline align-top dense v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                    <v-timeline-item>
                      <v-chip class="mt-1" color="green" text-color="white">
                        {{ item.horario.descricao }} | {{ item.dia.descricao }}
                      </v-chip>

                      <v-btn class="ml-2" @click="deleteRelacaoDiaHorario(i, relacoes.indexOf(relacao))" color="error"
                        fab small dark>
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
              </v-card>
            </template>
          </v-dialog>

          <v-col v-if="!editing" cols="12" xs="12" sm="12" md="12">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias e Horários</e-label>
              </v-card-title>
              <v-card-text>
                <div v-if="relacoesDiasHorarios.length === 0">
                  <p class="text-center">Não há horários selecionados</p>
                </div>
                <v-row v-else>
                  <v-col cols="7" class="text-left">
                    <span class="text-uppercase">Horário</span>
                  </v-col>
                  <v-col cols="" class="text-left">
                    <span class="text-uppercase">Dia</span>
                  </v-col>
                </v-row>
                <v-list>
                  <v-list-item v-for="(item, i) in relacoesDiasHorarios" :key="i">
                    <v-row>
                      <v-col cols="7" class="text-left">
                        {{ item.horario.descricao }}
                      </v-col>
                      <v-col cols="5" class="text-left">
                        {{ item.dia.descricao }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="editing" cols="12" xs="12" sm="12" md="12">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias e Horários</e-label>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="7" class="text-left">
                    <span class="text-uppercase">Horário</span>
                  </v-col>
                  <v-col cols="" class="text-left">
                    <span class="text-uppercase">Dia</span>
                  </v-col>
                </v-row>
                <v-list>
                  <v-list-item v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                    <v-row>
                      <v-col cols="7" class="text-left">
                        {{ item.horario.descricao }}
                      </v-col>
                      <v-col cols="5" class="text-left">
                        {{ item.dia.descricao }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="pt-0 pb-0" cols="1">
            <v-btn v-if="relacoes.length > 1" class="mt-7" color="error"
              @click="() => (relacoes = relacoes.filter((relacaoObj) => relacaoObj !== relacao))"
              :disabled="submittingForm"><v-icon small>fa-trash</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4" class="d-flex justify-space-between">
            <div class="d-flex">
              <v-btn color="primary" :disabled="submittingForm" :loading="submittingForm" type="submit">Enviar
                Dados</v-btn>
              <v-btn class="ml-3" v-if="!editing" color="secondary" @click="adicionarRelacao"
                :disabled="submittingForm">
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import Vue from "vue";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.loadData();
  },
  computed: {
    dadosEtapa1Validos() {
      return (
        this.novoProfessor.nome &&
        this.novoProfessor.email &&
        this.novoProfessor.cpf &&
        this.novoProfessor.dataNascimento
      );
    },
  },

  data() {
    return {
      horariosList: [],
      submittingForm: false,
      professoresList: [],
      turmasList: [],
      form: {},
      relacoes: [{}],
      disciplinasList: [],
      carregandoProfessores: false,
      carregandoTurmas: false,
      carregandoDisciplinas: false,
      camposObrigatoriosNaoPreenchidos: false,
      relacoesDiasHorarios: [],
      relacoesDiasHorariosEdit: [],
      horario_selecionado_id: null,
      dia_da_semana: null,
      dialogVisible: false,
      diasDaSemana: [
        {
          id: 0,
          descricao: "Segunda",
        },
        {
          id: 1,
          descricao: "Terça",
        },
        {
          id: 2,
          descricao: "Quarta",
        },
        {
          id: 3,
          descricao: "Quinta",
        },
        {
          id: 4,
          descricao: "Sexta",
        },
        {
          id: 5,
          descricao: "Sábado",
        },
      ],
      modalCriarProfessor: false,
      usuarioSelecionado: null,
      professorNaoListado: false,
      professor_nao_listado: "",
      usuariosNaoListados: [],
      mostrarModalProfessor: false,
      stepAtual: 1,
      novoProfessor: {
        nome: "",
        email: "",
        cpf: "",
        dataNascimento: "",
        tipo: "",
        user_id: null,
        nao_listado: false,
      },
      formValidoEtapa2: false,
      formValidoEtapa3: false,
      etapaCriacaoProfessor: 1,
      menuDataNascimento: false,

      salvando: false,
      erroCadastro: null,
      rules: {
        required: (value) => !!value || "Campo obrigatório",
        email: (value) => /.+@.+\..+/.test(value) || "E-mail inválido",
        cpf: (value) => value.replace(/\D/g, "").length === 11 || "CPF inválido",
      },
      tiposProfessor: [
        { id: 0, descricao: "Professor" },
        { id: 1, descricao: "Professor Substituto" },
        { id: 2, descricao: "Professor Temporário" },
      ],
    };
  },
  watch: {
    "form.professor_nao_listado": function (userId) {
      if (userId && !this.modalCriarProfessor) {
        const user = this.usersSemProfessor.find((u) => u.id === userId);
        if (user) {
          this.usuarioSelecionado = user;
          this.novoProfessor = {
            nome: user.name,
            email: user.email,
            cpf: "",
            user_id: user.id,
          };

          this.etapaCriacaoProfessor = 1;
          this.modalCriarProfessor = true;
        }
      }
    },
  },
  methods: {
    adicionarHorario(relacao) {
      if (!this.dia_da_semana || !this.horario_selecionado_id) {
        this.camposObrigatoriosNaoPreenchidos = true;
        return;
      }
      const data = {
        relacao_id: relacao,
        horario: this.horario_selecionado_id,
        dia: this.dia_da_semana,
      };

      if (!this.editing) {
        this.relacoesDiasHorarios.push(data);
      }

      if (this.editing) {
        this.relacoesDiasHorariosEdit.push(data);
      }

      this.camposObrigatoriosNaoPreenchidos = false;
    },

    deleteRelacaoDiaHorario(i) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esse vinculo?",
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: false,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando o vinculo");
              try {
                if (!this.editing) {
                  this.relacoesDiasHorarios.splice(i, 1);
                }

                if (this.editing) {
                  this.relacoesDiasHorariosEdit.splice(i, 1);
                }
                this.$toast.success("Vinculo deletado com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    adicionarRelacao() {
      const ultimaRelacao = this.relacoes[this.relacoes.length - 1];
      this.relacoes.push({ ...ultimaRelacao });
    },

    async submitForm() {
      this.submittingForm = true;

      try {
        // Editando gestão
        if (this.editing) {
          const formVinculo = {
            ...this.relacoes[0],
            instrutor_id: this.form.instrutor_id,
            relacoesDiasHorarios: this.relacoesDiasHorariosEdit,
          };

          await this.$services.gestoesDeAulasService.atualizar(formVinculo);
          this.$toast.success("Vínculo atualizado com sucesso!");
        }

        // Criando uma nova gestão
        if (!this.editing) {
          if (!this.dia_da_semana || !this.horario_selecionado_id) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false; // Define submittingForm como false para permitir que o formulário seja enviado novamente após preencher os campos obrigatórios.
            return;
          }

          const formRelacoes = this.relacoes.map((relacao, index) => ({
            ...relacao,
            instrutor_id: this.form.instrutor_id,
            relacoesDiasHorarios: this.relacoesDiasHorarios.filter((r) => r.relacao_id === index),
          }));

          const responseData = await this.$services.gestoesDeAulasService.criar(formRelacoes);

          this.relacoes = responseData.filter((item) => item.errors);
          this.$toast.success("Vínculo(s) criado(s) com sucesso!");
        }

        if (this.relacoes.length === 0 || this.editing) {
          this.$router.push({ name: "gestoesDeAulas" });
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },

    async loadData() {
      try {
        this.$loaderService.open("Carregando dados");
        this.professoresList = await this.$services.professoresService.syncAll();
        this.usersSemProfessor = await this.$services.usuariosService.getUsersRoleProfessor();
        this.turmasList = await this.$services.turmasService.syncAll();
        this.disciplinasList = await this.$services.disciplinasService.syncAll();
        this.horariosList = await this.$services.horariosService.syncAll();
        this.horariosList = this.horariosList.horarios;

        if (this.editing) {
          const vinculo = await this.$services.gestoesDeAulasService.gestaoGeralId(
            parseInt(this.$route.params.gestaoDeAulasId, 10)
          );

          this.relacoesDiasHorariosEdit = vinculo.relacoesDiasHorarios ?? [];

          if (vinculo) {
            this.form.instrutor_id = vinculo.instrutor_id;
            this.relacoes = [vinculo];
          }
        }
        this.$loaderService.close();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getHorariosDaTurma(turma_id) {
      this.$loaderService.open("Carregando horários");
      try {
        if (turma_id) {
          this.horariosList = await this.$services.horariosService.getHorariosDoTurnoDaTurma(
            turma_id
          );
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar horários", error);
      } finally {
        this.$loaderService.close();
      }
    },
    abrirModalCriarProfessor(userId) {
      const user = this.usersSemProfessor.find((u) => u.id === userId);
      if (user) {
        Vue.set(this.novoProfessor, "nome", user.name);
        Vue.set(this.novoProfessor, "email", user.email);
        Vue.set(this.novoProfessor, "user_id", user.id);
        this.novoProfessor.cpf = "";
        this.novoProfessor.dataNascimento = "";
        this.novoProfessor.nao_listado = true;
        this.etapaCriacaoProfessor = 1;
        this.modalCriarProfessor = true;
      }
    },

    proximaEtapa() {
      if (this.$refs.formEtapa1.validate()) {
        this.etapaCriacaoProfessor = 2;
      }
    },

    async salvarNovoProfessor() {
      try {
        this.$loaderService.open("Salvando professor...");

        if (!this.novoProfessor.nome || !this.novoProfessor.email || !this.novoProfessor.cpf) {
          throw new Error("Dados incompletos do professor");
        }

        const dadosProfessor = {
          ...this.novoProfessor,
          cpf: this.novoProfessor.cpf.replace(/\D/g, ""),
          nao_listado: this.professorNaoListado,
        };

        const professorSalvo = await this.$services.professoresService.criarProfessorParaUser(
          dadosProfessor
        );

        this.professoresList.push(professorSalvo);
        this.form.instrutor_id = professorSalvo.id;
        this.form.professor_nao_listado = null;
        this.professorNaoListado = false;

        this.modalCriarProfessor = false;
        this.resetarFormulario();

        this.$toast.success("Professor cadastrado com sucesso!");
      } catch (error) {
        this.$handleError(error);
        this.erroCadastro = error.message || "Erro ao salvar professor";
      } finally {
        this.$loaderService.close();
      }
    },

    resetarFormulario() {
      this.etapaCriacaoProfessor = 1;
      this.professorNaoListado = false;
      this.novoProfessor = {
        nome: "",
        email: "",
        cpf: "",
        dataNascimento: "",
        nao_listado: false,
      };
      if (this.$refs.formEtapa1) {
        this.$refs.formEtapa1.resetValidation();
      }
    },
    regraCPF(value) {
      if (!value) return "O CPF é obrigatório";
      if (!this.validaCPF(value)) return "CPF inválido";
      return true;
    },

    validaCPF(cpf) {
      let Soma = 0;
      let Resto;

      const strCPF = String(cpf).replace(/[^\d]/g, "");

      if (strCPF.length !== 11) return false;

      if (
        [
          "00000000000",
          "11111111111",
          "22222222222",
          "33333333333",
          "44444444444",
          "55555555555",
          "66666666666",
          "77777777777",
          "88888888888",
          "99999999999",
        ].includes(strCPF)
      ) {
        return false;
      }

      for (let i = 1; i <= 9; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);

      Resto = (Soma * 10) % 11;
      if (Resto === 10 || Resto === 11) Resto = 0;
      if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);

      Resto = (Soma * 10) % 11;
      if (Resto === 10 || Resto === 11) Resto = 0;
      if (Resto !== parseInt(strCPF.substring(10, 11))) return false;

      return true;
    },
    handleProfessorNaoListadoChange(value) {
      this.novoProfessor.nao_listado = value;
    },
    formatarCPF(cpf) {
      return cpf ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "";
    },
    formatarData(data) {
      if (!data) return "";
      const [year, month, day] = data.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style></style>
